import { render, staticRenderFns } from "./AddOrUpdateDirectQuestionModal.vue?vue&type=template&id=0466f3c4&"
import script from "./AddOrUpdateDirectQuestionModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateDirectQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateDirectQuestionModal.vue?vue&type=style&index=0&id=0466f3c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports